import React from "react";
import { number, bool, string } from "prop-types";

import Icon from "../icon";

const Whatsapp = ({ width = 28, height = 28, isShareRequired, text }) => (
  <Icon type="whatsapp" isShareRequired={isShareRequired} text={text}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 28 28">
      <g transform="translate(.498 -.011)">
        <path d="M0 0H28V28H0z" transform="translate(-.498 .011)" fill="transparent" />
        <g transform="translate(-426.894 -321.478)">
          <path
            d="M1.416 14.975a9.984 9.984 0 118.652 5 9.975 9.975 0 01-4.775-1.215L0 20.148zm4.425 2.158a8.286 8.286 0 004.224 1.157 8.3 8.3 0 10-7.027-3.89l.2.314-.838 3.062 3.141-.824zm5.859-2.494a14.336 14.336 0 01-1.422-.525 11.121 11.121 0 01-4.262-3.767 4.853 4.853 0 01-1.021-2.581 2.8 2.8 0 01.873-2.081.916.916 0 01.665-.312c.166 0 .333 0 .478.009h.056c.145 0 .326 0 .505.427.208.5.707 1.728.769 1.852a.459.459 0 01.021.437 1.7 1.7 0 01-.249.416c-.125.146-.262.325-.374.437s-.255.259-.109.509a7.517 7.517 0 001.387 1.73 6.814 6.814 0 002.006 1.238c.249.125.395.1.54-.062s.624-.728.79-.978.333-.208.561-.125 1.455.687 1.7.812.416.187.478.291a2.086 2.086 0 01-.145 1.186 2.569 2.569 0 01-1.684 1.186 4.078 4.078 0 01-.605.048 3.165 3.165 0 01-.958-.147z"
            transform="translate(430.791 325.415)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  </Icon>
);

Whatsapp.propTypes = {
  width: number,
  height: number,
  isShareRequired: bool,
  text: string,
};

export default Whatsapp;
